import { holidaysService } from '../../../services/Holidays'
import { serviceEntityService } from '../../../services/Service'
import { workingHoursService } from '../../../services/WorkingHours'
import { createAction } from '../helpers'
import {
  ActionsUnion,
  IMap,
  IProviderObject,
  IProviderProductObject,
  IHolidayItem,
  IServiceCreateObject,
  IServiceEditStepData,
  IServiceFetchItemResponse,
  IServiceFetchItemsResponse,
  IServiceObject,
  IServiceUpdateObject,
  ITripMenuServiceObject,
  IWorkingHoursItem,
  IServiceStateFilters,
  IServicePricingType,
  IServicePricingTypeObject,
  IServiceLocationObject,
  IPaymentMethods,
  IAddPaymentMethod,
  IServiceGroupRideRadiusUpdate,
  IHotspot,
  IServicePricingUpdatePayload
} from '../../../types/index'
import * as constants from '../../constants'
import { domainToUnicode } from 'url'
import { paymentMethodsService } from 'src/services/PaymentMethods'
import { DEFAULT_PAYMENT_METHODS } from 'src/constants/service'
import { servicePricingService } from 'src/services/ServicePricing'

export const actionCreators = {
  //Async action creators
  searchRequest: () => createAction(constants.SERVICE_SEARCH_REQUEST),
  searchSuccess: (services: IServiceObject[]) => createAction(constants.SERVICE_SEARCH_SUCCESS, services),
  searchFail: (error: string) => createAction(constants.SERVICE_SEARCH_FAIL, error),

  serviceCreateRequest: () => createAction(constants.SERVICE_CREATE_REQUEST),
  serviceCreateSuccess: (service: IServiceObject) => createAction(constants.SERVICE_CREATE_SUCCESS, service),
  serviceCreateFail: (error: string) => createAction(constants.SERVICE_CREATE_FAIL, error),

  serviceListRequest: () => createAction(constants.SERVICE_LIST_REQUEST),
  serviceListSuccess: (services: IMap<IServiceObject>) => createAction(constants.SERVICE_LIST_SUCCESS, services),
  serviceListFail: (error: string) => createAction(constants.SERVICE_LIST_FAIL, error),

  serviceListTotalSuccess: (total: number) => createAction(constants.SERVICE_LIST_TOTAL_SUCCESS, total),

  tripMenuServiceListRequest: () => createAction(constants.TRIP_MENU_SERVICE_LIST_REQUEST),
  tripMenuServiceListSuccess: (services: IMap<ITripMenuServiceObject>) =>
    createAction(constants.TRIP_MENU_SERVICE_LIST_SUCCESS, services),
  tripMenuServiceListFail: (error: string) => createAction(constants.TRIP_MENU_SERVICE_LIST_FAIL, error),

  serviceItemRequest: () => createAction(constants.SERVICE_ITEM_REQUEST),
  serviceItemSuccess: (service: IMap<IServiceObject>) => createAction(constants.SERVICE_ITEM_SUCCESS, service),
  serviceItemFail: (error: string) => createAction(constants.SERVICE_ITEM_FAIL, error),

  serviceRestoreRequest: () => createAction(constants.SERVICE_RESTORE_REQUEST),
  serviceRestoreSuccess: () => createAction(constants.SERVICE_RESTORE_SUCCESS),
  serviceRestoreFail: (error: string) => createAction(constants.SERVICE_RESTORE_FAIL, error),

  serviceArchiveRequest: () => createAction(constants.SERVICE_ARCHIVE_REQUEST),
  serviceArchiveSuccess: () => createAction(constants.SERVICE_ARCHIVE_SUCCESS),
  serviceArchiveFail: (error: string) => createAction(constants.SERVICE_ARCHIVE_FAIL, error),

  workingHoursRemoveItemSuccess: (id: string) => createAction(constants.WORKING_HOURS_REMOVE_ITEM_SUCCESS, id),
  workingHoursRemoveItemFail: (error: string) => createAction(constants.WORKING_HOURS_REMOVE_ITEM_FAIL, error),

  holidayRemoveItemSuccess: (id: string) => createAction(constants.HOLIDAY_REMOVE_ITEM_SUCCESS, id),
  holidayRemoveItemFail: (error: string) => createAction(constants.HOLIDAY_REMOVE_ITEM_FAIL, error),

  //Sync local action creators
  serviceRestoreModalShow: (serviceId: string) => createAction(constants.SERVICE_RESTORE_MODAL_SHOW, serviceId),
  serviceRestoreModalHide: () => createAction(constants.SERVICE_RESTORE_MODAL_HIDE),

  serviceArchiveModalShow: (serviceId: string) => createAction(constants.SERVICE_ARCHIVE_MODAL_SHOW, serviceId),
  serviceArchiveModalHide: () => createAction(constants.SERVICE_ARCHIVE_MODAL_HIDE),

  serviceEditClearState: () => createAction(constants.SERVICE_EDIT_CLEAR_STATE),

  updateServiceFilters: (filters: IServiceStateFilters) => createAction(constants.UPDATE_SERVICE_FILTERS, filters),

  serviceCreateSetServiceId: (serviceId: string) => createAction(constants.SERVICE_EDIT_SET_SERVICE_ID, serviceId),
  serviceCreateSetChanged: (changed: boolean) => createAction(constants.SERVICE_EDIT_SET_CHANGED, changed),
  serviceCreateSetUpdatingError: (error: string) => createAction(constants.SERVICE_EDIT_SET_UPDATING_ERROR, error),
  serviceCreateSetUpdating: (updating: boolean) => createAction(constants.SERVICE_EDIT_SET_UPDATING, updating),
  serviceCreateSetFetching: (fetching: boolean) => createAction(constants.SERVICE_EDIT_SET_FETCHING, fetching),
  serviceCreateSetFetchingError: (error: string) => createAction(constants.SERVICE_EDIT_SET_FETCHING_ERROR, error),

  serviceCreateSetCurrentStep: (currentStep: IServiceEditStepData) =>
    createAction(constants.SERVICE_EDIT_SET_CURRENT_STEP, currentStep),
  serviceCreateSetStepCompleted: (step: number, completed: boolean) =>
    createAction(constants.SERVICE_EDIT_SET_COMPLETED, { step, completed }),
  workingHoursAddItem: (workingHours: IWorkingHoursItem) =>
    createAction(constants.WORKING_HOURS_ADD_ITEM, workingHours),
  workingHoursSetFrom: (workingHoursId: string, from: string) =>
    createAction(constants.WORKING_HOURS_SET_FROM, { workingHoursId, from }),
  workingHoursSetUntil: (workingHoursId: string, until: string) =>
    createAction(constants.WORKING_HOURS_SET_UNTIL, { workingHoursId, until }),
  workingHoursSetDays: (workingHoursId: string, days: string[]) =>
    createAction(constants.WORKING_HOURS_SET_DAYS, { workingHoursId, days }),
  workingHoursSetAllDaysActive: (isAllDaysActive: boolean, id: string) =>
    createAction(constants.WORKING_HOURS_SET_ALL_DAYS_ACTIVE, { isAllDaysActive, id }),
  workingHoursRequestSuccesss: (workingHoursList: IWorkingHoursItem[]) =>
    createAction(constants.WORKING_HOURS_SUCCESS, workingHoursList),

  holidaysAddItem: (holidayItem: IHolidayItem) => createAction(constants.HOLIDAYS_ADD_ITEM, holidayItem),
  holidaysRemoveItem: (holidayItem: IHolidayItem) => createAction(constants.HOLIDAYS_REMOVE_ITEM, holidayItem),
  holidaysRequestSuccess: (holidaysList: IHolidayItem[]) => createAction(constants.HOLIDAYS_SUCCESS, holidaysList),

  holidaysSetFrom: (holidayItemId: string, from: string) =>
    createAction(constants.HOLIDAYS_SET_FROM, { holidayItemId, from }),
  holidaysSetUntil: (holidayItemId: string, until: string) =>
    createAction(constants.HOLIDAYS_SET_UNTIL, { holidayItemId, until }),
  holidaysSetDate: (holidayItemId: string, date: Date) =>
    createAction(constants.HOLIDAYS_SET_DATE, { holidayItemId, date }),
  selectProvider: (providerId: string, serviceId: string) =>
    createAction(constants.SERVICE_SELECT_PROVIDER, { serviceId, providerId }),
  removeProvider: (providerId: string, serviceId: string, productsIds: string[]) =>
    createAction(constants.SERVICE_REMOVE_PROVIDER, { serviceId, providerId, productsIds }),
  selectProviderProduct: (product: IProviderProductObject, serviceId: string) =>
    createAction(constants.SERVICE_SELECT_PRODUCT, { serviceId, product }),
  removeProviderProduct: (productId: string, serviceId: string) =>
    createAction(constants.SERVICE_REMOVE_PRODUCT, { serviceId, productId }),

  serviceListUpdateColumns: (columns: string[]) => createAction(constants.SERVICE_LIST_UPDATE_COLUMNS, columns),

  serviceProvidersSuccess: (providers: IProviderObject[]) =>
    createAction(constants.SERVICE_PROVIDERS_SUCCESS, providers),

  //PricingType Fetch All
  servicePricingTypeSuccess: (servicePricingType: IServicePricingType) =>
    createAction(constants.SERVICE_PRICING_TYPE_REQUEST_SUCCESS, servicePricingType),
  servicePricingTypeFail: (error: string) => createAction(constants.SERVICE_PRICING_TYPE_REQUEST_FAIL, error),

  //PricingType Edit All
  servicePricingTypeEditSuccess: (servicePricingType: IServicePricingTypeObject) =>
    createAction(constants.SERVICE_PRICING_TYPE_EDIT_SUCCESS, servicePricingType),
  servicePricingTypeEditFail: (error: string) => createAction(constants.SERVICE_PRICING_TYPE_EDIT_FAIL, error),

  serviceLocationListRequest: () => createAction(constants.SERVICE_LOCATION_LIST_REQUEST),
  serviceLocationListSuccess: (list: IMap<IServiceLocationObject>) =>
    createAction(constants.SERVICE_LOCATION_LIST_SUCCESS, list),
  serviceLocationListFail: (error: string) => createAction(constants.SERVICE_LOCATION_LIST_FAIL, error),

  serviceCreateLocationRequest: () => createAction(constants.SERVICE_CREATE_LOCATION_REQUEST),
  serviceCreateLocationSuccess: (location: IServiceLocationObject) =>
    createAction(constants.SERVICE_CREATE_LOCATION_SUCCESS, location),
  serviceCreateLocationFailure: (error: string) => createAction(constants.SERVICE_CREATE_LOCATION_SUCCESS, error),

  serviceUpdateLocationsRequest: () => createAction(constants.SERVICE_UPDATE_LOCATION_REQUEST),
  serviceUpdateLocationsSuccess: (location: IServiceLocationObject) =>
    createAction(constants.SERVICE_UPDATE_LOCATION_SUCCESS, { location }),
  serviceUpdateLocationsFailure: (error: string) => createAction(constants.SERVICE_UPDATE_LOCATION_SUCCESS, error),

  serviceDeleteLocationRequest: () => createAction(constants.SERVICE_DELETE_LOCATION_REQUEST),
  serviceDeleteLocationSuccess: (id: string) => createAction(constants.SERVICE_DELETE_LOCATION_SUCCESS, { id }),
  serviceDeleteLocationFailure: (error: string) => createAction(constants.SERVICE_DELETE_LOCATION_FAIL, error),

  paymentMethodsListRequest: () => createAction(constants.PAYMENT_METHODS_LIST_REQUEST),
  paymentMethodsListSuccess: (paymentMethods: IPaymentMethods[]) =>
    createAction(constants.PAYMENT_METHODS_LIST_SUCCESS, paymentMethods),
  paymentMethodsListFail: (error: string) => createAction(constants.PAYMENT_METHODS_LIST_FAIL, error),

  paymentMethodsUpdateRequest: () => createAction(constants.PAYMENT_METHODS_UPDATE_REQUEST),
  paymentMethodsUpdateSuccess: (paymentMethods: IPaymentMethods[]) =>
    createAction(constants.PAYMENT_METHODS_LIST_SUCCESS, paymentMethods),
  paymentMethodsUpdateFail: (error: string) => createAction(constants.PAYMENT_METHODS_UPDATE_FAIL, error),

  paymentMethodsAddSuccess: (paymentMethod: IPaymentMethods) =>
    createAction(constants.PAYMENT_METHODS_ADD_SUCCESS, paymentMethod),

  // DESIGNATED ZONE
  serviceDesignatedZoneDeleteRequest: () => createAction(constants.SERVICE_DESIGNATED_ZONE_DELETE_REQUEST),
  serviceDesignatedZoneDeleteSuccess: (message: string) =>
    createAction(constants.SERVICE_DESIGNATED_ZONE_DELETE_SUCCESS_MESSAGE, message),
  serviceDesignatedZoneDeleteFail: (error: string) =>
    createAction(constants.SERVICE_DESIGNATED_ZONE_DELETE_FAIL, error),

  serviceHotspotsListRequest: () => createAction(constants.SERVICE_HOTSPOTS_LIST_REQUEST),
  serviceHotspotsListSuccess: (paymentMethods: IPaymentMethods[]) =>
    createAction(constants.SERVICE_HOTSPOTS_LIST_SUCCESS, paymentMethods),
  serviceHotspotsListFail: (error: string) => createAction(constants.SERVICE_HOTSPOTS_LIST_FAIL, error),

  serviceHotspotsUpdateRequest: () => createAction(constants.SERVICE_HOTSPOTS_UPDATE_REQUEST),
  serviceHotspotsUpdateSuccess: (data: any) => createAction(constants.SERVICE_HOTSPOTS_UPDATE_SUCCESS_MESSAGE, data),
  serviceHotspotsUpdateFail: (error: string) => createAction(constants.SERVICE_HOTSPOTS_UPDATE_FAIL, error),

  serviceDesignatedHotspotDeleteRequest: () => createAction(constants.SERVICE_DESIGNATED_HOTSPOT_DELETE_REQUEST),
  serviceDesignatedHotspotDeleteSuccess: (message: string) =>
    createAction(constants.SERVICE_DESIGNATED_HOTSPOT_DELETE_SUCCESS_MESSAGE, message),
  serviceDesignatedHotspotDeleteFail: (error: string) =>
    createAction(constants.SERVICE_DESIGNATED_HOTSPOT_DELETE_FAIL, error),

  servicePricingDiscountRequest: () => createAction(constants.SERVICE_PRICING_DISCOUNT_REQUEST),
  servicePricingDiscountSuccess: (data: any) => createAction(constants.SERVICE_PRICING_DISCOUNT_SUCCESS, data),
  servicePricingDiscountFail: (error: string) => createAction(constants.SERVICE_PRICING_DISCOUNT_FAIL, error)
}

export type IServiceActions = ActionsUnion<typeof actionCreators>

export const fetchServiceList = (
  type: string,
  orgId: string,
  sort?: string,
  orderBy?: string,
  take?: number,
  skip?: number
) => (dispatch: any) => {
  const { serviceListRequest, serviceListSuccess, serviceListFail, serviceListTotalSuccess } = actionCreators
  dispatch(serviceListRequest())

  if (orgId) {
    serviceEntityService
      .fetchServices(type, orgId, sort, orderBy, take, skip)
      .then((data: IServiceFetchItemsResponse) => {
        dispatch(serviceListSuccess(data.services))
        dispatch(serviceListTotalSuccess(data.total))
      })
      .catch(error => dispatch(serviceListFail(error.data)))
  }
}

export const fetchTripMenuServiceList = (type: string, orgId: string) => (dispatch: any) => {
  const { tripMenuServiceListRequest, tripMenuServiceListSuccess, tripMenuServiceListFail } = actionCreators
  dispatch(tripMenuServiceListRequest())

  if (orgId) {
    serviceEntityService
      .fetchServices(type, orgId)
      .then((data: IServiceFetchItemsResponse) => {
        dispatch(tripMenuServiceListSuccess(data.services))
      })
      .catch(error => dispatch(tripMenuServiceListFail(error.data)))
  }
}

export const fetchService = (serviceId: string) => (dispatch: any) => {
  const { serviceItemRequest, serviceItemSuccess, serviceItemFail } = actionCreators
  dispatch(serviceItemRequest())
  serviceEntityService
    .fetchServiceMainInfo(serviceId)
    .then((data: IServiceFetchItemResponse) => {
      dispatch(serviceItemSuccess(data.services))
    })
    .catch(error => {
      dispatch(serviceItemFail(error.data))
    })
}

export const createService = (service: IServiceCreateObject) => (dispatch: any) => {
  const {
    serviceCreateRequest,
    serviceCreateSuccess,
    serviceCreateFail,
    serviceCreateSetStepCompleted
  } = actionCreators
  dispatch(serviceCreateRequest())
  return serviceEntityService.createService(service).then(
    (data: IServiceObject) => {
      dispatch(serviceCreateSuccess(data))
      dispatch(serviceCreateSetStepCompleted(0, true))
      return data
    },
    error => {
      dispatch(serviceCreateFail(error))
      throw error
    }
  )
}

export const updateService = (service: IServiceUpdateObject) => (dispatch: any) => {
  const {
    serviceCreateRequest,
    serviceCreateSuccess,
    serviceCreateFail,
    serviceCreateSetStepCompleted
  } = actionCreators
  dispatch(serviceCreateRequest())
  return serviceEntityService.updateService(service).then(
    data => {
      dispatch(serviceCreateSuccess(data))
      dispatch(serviceCreateSetStepCompleted(0, true))
      return data
    },
    error => {
      dispatch(serviceCreateFail(error))
      throw error
    }
  )
}

export const updateServiceGroupRideRadius = (service: IServiceGroupRideRadiusUpdate) => (dispatch: any) => {
  const {
    serviceCreateRequest,
    serviceCreateSuccess,
    serviceCreateFail,
    serviceCreateSetStepCompleted
  } = actionCreators
  dispatch(serviceCreateRequest())
  return serviceEntityService.updateServiceGroupRideRadius(service).then(
    data => {
      dispatch(serviceCreateSuccess(data))
      dispatch(serviceCreateSetStepCompleted(0, true))
      return data
    },
    error => {
      dispatch(serviceCreateFail(error))
      throw error
    }
  )
}

// TOBE removed
export const updateProviders = (serviceId: string, serviceProductsIds: string[]) => (dispatch: any) => {
  const { serviceCreateSetUpdating, serviceCreateSetUpdatingError, serviceCreateSetStepCompleted } = actionCreators
  dispatch(serviceCreateSetUpdating(true))
  dispatch(serviceCreateSetUpdatingError(''))
  return serviceEntityService.updateServiceProducts(serviceId, serviceProductsIds).then(
    () => {
      dispatch(serviceCreateSetUpdating(false))
      dispatch(serviceCreateSetStepCompleted(1, true))
      return
    },
    error => {
      dispatch(serviceCreateSetUpdating(false))
      dispatch(serviceCreateSetUpdatingError(error))
      return error
    }
  )
}

export const updateProducts = (serviceId: string, productIds: string[]) => (dispatch: any) => {
  const { serviceCreateSetUpdating, serviceCreateSetUpdatingError, serviceCreateSetStepCompleted } = actionCreators
  dispatch(serviceCreateSetUpdating(true))
  return serviceEntityService.updateServiceProducts(serviceId, productIds).then(
    () => {
      dispatch(serviceCreateSetUpdating(false))
      dispatch(serviceCreateSetStepCompleted(1, true))
    },
    error => {
      dispatch(serviceCreateSetUpdating(false))
      dispatch(serviceCreateSetUpdatingError(error))
    }
  )
}

export const fetchServiceDays = (serviceId: string, orgId: string) => (dispatch: any) => {
  const {
    serviceCreateSetFetching,
    serviceCreateSetFetchingError,
    workingHoursRequestSuccesss,
    holidaysRequestSuccess
  } = actionCreators
  dispatch(serviceCreateSetFetching(true))
  dispatch(serviceCreateSetFetchingError(''))
  return Promise.all([workingHoursService.fetchWorkingHours(serviceId), holidaysService.fetchHolidays(serviceId)])
    .then(result => {
      dispatch(serviceCreateSetFetching(false))
      dispatch(serviceCreateSetFetchingError(''))
      dispatch(workingHoursRequestSuccesss(result[0]))
      dispatch(holidaysRequestSuccess(result[1]))
    })
    .catch(error => {
      dispatch(serviceCreateSetFetching(false))
      console.log('fetchServiceDays ERROR', error)
      dispatch(serviceCreateSetFetchingError(error.request.responseText))
    })
}

export const updateServiceDays = (
  serviceId: string,
  isAllDaysActive: boolean,
  workingHoursItems: IWorkingHoursItem[],
  holidayItems: IHolidayItem[]
) => (dispatch: any) => {
  const { serviceCreateSetUpdating, serviceCreateSetUpdatingError, serviceCreateSetStepCompleted } = actionCreators
  dispatch(serviceCreateSetUpdating(true))
  dispatch(serviceCreateSetUpdatingError(''))

  const workingHoursItemsToUpsert = workingHoursItems.map((sd: IWorkingHoursItem) => {
    if (sd.id.indexOf('new') > -1) {
      delete sd.id
    }
    return sd
  })

  const holidayItemsToUpsert = holidayItems.map((sd: IHolidayItem) => {
    if (sd.id.indexOf('new') > -1) {
      delete sd.id
    }
    return sd
  })

  return Promise.all([
    serviceEntityService.saveServiceDaysHours(serviceId, isAllDaysActive, workingHoursItemsToUpsert),
    holidaysService.updateHolidays(serviceId, holidayItemsToUpsert)
  ])
    .then(() => {
      dispatch(serviceCreateSetUpdating(false))
      dispatch(serviceCreateSetUpdatingError(''))
      dispatch(serviceCreateSetStepCompleted(2, true))
      return
    })
    .catch(error => {
      dispatch(serviceCreateSetUpdating(false))
      dispatch(serviceCreateSetUpdatingError(error))
      return error
    })
}

export function removeServiceDaysHours(id: string) {
  const {
    serviceCreateSetUpdating,
    serviceCreateSetUpdatingError,
    serviceCreateSetStepCompleted,
    workingHoursRemoveItemSuccess,
    workingHoursRemoveItemFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(serviceCreateSetUpdating(true))
    return workingHoursService.removeServiceDaysHours(id).then(
      () => {
        dispatch(serviceCreateSetUpdating(false))
        dispatch(serviceCreateSetStepCompleted(2, true))
        dispatch(workingHoursRemoveItemSuccess(id))
      },
      ({ data }) => {
        dispatch(serviceCreateSetUpdating(false))
        dispatch(workingHoursRemoveItemFail(data))
        return
        setTimeout(() => {
          dispatch(serviceCreateSetUpdating(false))
          dispatch(workingHoursRemoveItemFail(''))
        }, 5000)
        throw new Error(data)
      }
    )
  }
}

export function removeHoliday(id: string) {
  const {
    serviceCreateSetUpdating,
    serviceCreateSetUpdatingError,
    serviceCreateSetStepCompleted,
    holidayRemoveItemSuccess,
    holidayRemoveItemFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(serviceCreateSetUpdating(true))
    return holidaysService.removeHoliday(id).then(
      () => {
        dispatch(serviceCreateSetUpdating(false))
        dispatch(serviceCreateSetStepCompleted(2, true))
        dispatch(holidayRemoveItemSuccess(id))
      },
      ({ data }) => {
        dispatch(serviceCreateSetUpdating(false))
        dispatch(holidayRemoveItemFail(data))
        return
        setTimeout(() => {
          dispatch(serviceCreateSetUpdating(false))
          dispatch(holidayRemoveItemFail(''))
        }, 5000)
        throw new Error(data)
      }
    )
  }
}
export const serviceRestore = (serviceId: string) => (dispatch: any) => {
  const { serviceRestoreRequest, serviceRestoreSuccess, serviceRestoreFail } = actionCreators
  dispatch(serviceRestoreRequest())
  serviceEntityService.restore(serviceId).then(
    () => {
      dispatch(serviceRestoreSuccess())
    },
    error => {
      dispatch(serviceRestoreFail(error))
    }
  )
}

export const serviceArchive = (serviceId: string) => (dispatch: any) => {
  const { serviceArchiveRequest, serviceArchiveSuccess, serviceArchiveFail } = actionCreators
  dispatch(serviceArchiveRequest())
  serviceEntityService.archive(serviceId).then(
    () => {
      dispatch(serviceArchiveSuccess())
    },
    error => {
      dispatch(serviceArchiveFail(error))
    }
  )
}

export const search = (orgId: string, query: string, types: string) => (dispatch: any) => {
  const { searchRequest, searchSuccess, searchFail } = actionCreators
  dispatch(searchRequest())
  serviceEntityService
    .search(orgId, query, types)
    .then((data: IServiceObject[]) => dispatch(searchSuccess(data)), (error: string) => dispatch(searchFail(error)))
}

export const fetchServicePricingType = (serviceId: string) => (dispatch: any) => {
  const { servicePricingTypeSuccess } = actionCreators
  serviceEntityService
    .fetchServicePricingType(serviceId)
    .then(
      result => dispatch(servicePricingTypeSuccess(result.data)),
      (error: string) => dispatch(actionCreators.servicePricingTypeFail(error))
    )
}

export const fetchServiceHotspotList = (serviceId: string) => (dispatch: any) => {
  const { serviceHotspotsListSuccess } = actionCreators
  return serviceEntityService
    .fetchServiceHotspots(serviceId)
    .then(
      result => dispatch(serviceHotspotsListSuccess(result.data)),
      (error: string) => dispatch(actionCreators.serviceHotspotsListFail(error))
    )
}

// DESIGNATED ZONE

export const deleteServiceDesignatedZone = (id: string) => (dispatch: any) => {
  const { serviceDesignatedZoneDeleteSuccess, serviceDesignatedZoneDeleteFail } = actionCreators
  return serviceEntityService
    .deleteServiceDesignatedZone(id)
    .then(
      result => dispatch(serviceDesignatedZoneDeleteSuccess('Designated zone deleted successfully')),
      (error: string) => dispatch(serviceDesignatedZoneDeleteFail('Failed to delete designated zone.'))
    )
}

export const updateServiceHotspots = (payload: { hotspots: IHotspot[] }) => (dispatch: any) => {
  const { serviceHotspotsUpdateSuccess } = actionCreators
  return serviceEntityService
    .updateServiceHotspots(payload)
    .then(
      result => dispatch(serviceHotspotsUpdateSuccess('Hotspots updated successfully.')),
      (error: string) => dispatch(actionCreators.serviceHotspotsUpdateFail('Failed to update hotspot.'))
    )
}
export const deleteServiceDesignatedHotspot = (id: string) => (dispatch: any) => {
  const { serviceDesignatedHotspotDeleteSuccess, serviceDesignatedHotspotDeleteFail } = actionCreators
  return serviceEntityService
    .deleteServiceDesignatedHotspot(id)
    .then(
      result => dispatch(serviceDesignatedHotspotDeleteSuccess('Hotspot deleted successfully')),
      (error: string) => dispatch(serviceDesignatedHotspotDeleteFail('Failed to delete hotspot.'))
    )
}

//PricingType Fetching Data Function

//PricingType Updating Data Function Based on Default URL
export const UpdateAllServicePricingType = (serviceId: string, dto: IServicePricingTypeObject) => (dispatch: any) => {
  const { servicePricingTypeSuccess } = actionCreators
  serviceEntityService
    .UpdateAllServicePricingType(serviceId, dto)
    .then(
      result => dispatch(servicePricingTypeSuccess(result.data)),
      (error: string) => dispatch(actionCreators.servicePricingTypeFail(error))
    )
}

export const getSuggestedLocationList = (serviceId: string) => (dispatch: any) => {
  const { serviceLocationListSuccess } = actionCreators
  serviceEntityService
    .getServiceLocationList(serviceId)
    .then(
      result => dispatch(serviceLocationListSuccess(result.data)),
      (error: string) => dispatch(actionCreators.serviceLocationListFail(error))
    )
}

export const createSuggestedLocation = (serviceId: string, dto: IServiceLocationObject) => (dispatch: any) => {
  const { serviceCreateLocationRequest, serviceCreateLocationSuccess, serviceCreateLocationFailure } = actionCreators
  dispatch(serviceCreateLocationRequest())
  return serviceEntityService.createServiceLocation(serviceId, dto).then(
    result => {
      dispatch(serviceCreateLocationSuccess(result.data))
      return result.data
    },
    ({ data }) => {
      dispatch(serviceCreateLocationFailure(data))
      setTimeout(() => {
        dispatch(serviceCreateLocationFailure(''))
      }, 5000)
      throw new Error(data)
    }
  )
}

export const updateSuggestedLocation = (location: IServiceLocationObject) => (dispatch: any) => {
  const { serviceUpdateLocationsRequest, serviceUpdateLocationsSuccess, serviceUpdateLocationsFailure } = actionCreators
  dispatch(serviceUpdateLocationsRequest())
  return serviceEntityService.updateServiceLocation(location).then(
    (response: any) => {
      dispatch(serviceUpdateLocationsSuccess(location))
    },
    ({ data }) => {
      dispatch(serviceUpdateLocationsFailure(data))
      setTimeout(() => {
        dispatch(serviceUpdateLocationsFailure(''))
      }, 5000)
      throw new Error(data)
    }
  )
}

export const deleteSuggestedLocation = (id: string) => (dispatch: any) => {
  const { serviceDeleteLocationRequest, serviceDeleteLocationSuccess, serviceDeleteLocationFailure } = actionCreators
  dispatch(serviceDeleteLocationRequest())
  return serviceEntityService.deleteServiceLocation(id).then(
    () => {
      dispatch(serviceDeleteLocationSuccess(id))
    },
    ({ data }) => {
      dispatch(serviceDeleteLocationFailure(data))
      setTimeout(() => {
        dispatch(serviceDeleteLocationFailure(''))
      }, 5000)
      throw new Error(data)
    }
  )
}

export const fetchPaymentMethods = (serviceId: string) => (dispatch: any) => {
  const { paymentMethodsListSuccess } = actionCreators
  return paymentMethodsService.fetchPaymentMethods(serviceId).then((result: IPaymentMethods[]) => {
    dispatch(paymentMethodsListSuccess(result))
    return result
  })
}

export const updatePaymentMethods = (serviceId: string, paymentMethods: IPaymentMethods[]) => (dispatch: any) => {
  const { paymentMethodsUpdateSuccess } = actionCreators
  paymentMethodsService.updatePaymentMethods(serviceId, paymentMethods).then((result: IPaymentMethods[]) => {
    dispatch(paymentMethodsUpdateSuccess(result))
  })
}
export const addPaymentMethod = (serviceId: string, paymentMethods: IPaymentMethods[]) => (dispatch: any) => {
  const { paymentMethodsUpdateSuccess } = actionCreators
  let payload: IPaymentMethods[] | IAddPaymentMethod[] = paymentMethods

  if (paymentMethods.length <= 0) {
    payload = DEFAULT_PAYMENT_METHODS.map(method => {
      method.serviceId = serviceId
      return method
    })
  }
  paymentMethodsService.updatePaymentMethods(serviceId, payload).then((result: IPaymentMethods[]) => {
    return dispatch(paymentMethodsUpdateSuccess(result))
  })
}

export const fetchServicePricingDiscount = (serviceId: string) => async (dispatch: any) => {
  const { servicePricingDiscountRequest, servicePricingDiscountSuccess, servicePricingDiscountFail } = actionCreators
  dispatch(servicePricingDiscountRequest())
  try {
    const servicePricingDiscountData = await servicePricingService.getServicePricingDiscount(serviceId)
    dispatch(servicePricingDiscountSuccess(servicePricingDiscountData))
  } catch (error) {
    console.error(error)
    dispatch(servicePricingDiscountFail('Error: Fetching service pricing discount failed.'))
  }
}

export const generateDefaultServicePricingDiscount = (serviceId: string) => async (dispatch: any) => {
  const { servicePricingDiscountRequest, servicePricingDiscountSuccess, servicePricingDiscountFail } = actionCreators
  dispatch(servicePricingDiscountRequest())
  try {
    const generatedPricingDiscountData = await servicePricingService.generateDefaultServicePricingDiscount(serviceId)
    dispatch(servicePricingDiscountSuccess(generatedPricingDiscountData))
  } catch (error) {
    console.error(error)
    dispatch(servicePricingDiscountFail('Error: Generating service pricing discount default values failed.'))
  }
}

export const updateServicePricingDiscount = (serviceId: string, payload: IServicePricingUpdatePayload) => async (
  dispatch: any
) => {
  const { servicePricingDiscountRequest, servicePricingDiscountSuccess, servicePricingDiscountFail } = actionCreators
  dispatch(servicePricingDiscountRequest())
  try {
    const updatedPricingDiscountData = await servicePricingService.updateServicePricingDiscount(serviceId, payload)
    dispatch(servicePricingDiscountSuccess(updatedPricingDiscountData))
  } catch (error) {
    console.error(error)
    dispatch(servicePricingDiscountFail('Error: Failed to update service pricing discount.'))
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/services/index.ts